import { Component } from '@angular/core';
import { AppBreadcrumbComponent } from "../../../layouts/full/shared/breadcrumb/breadcrumb.component";
import { MaterialModule } from 'src/app/material.module';
import { TablerIconsModule } from 'angular-tabler-icons';
import { CommonModule } from '@angular/common';
import { AppointmentTypeComponent } from "./appointment-type/appointment-type.component";
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-appointment-tab',
  standalone: true,
  imports: [AppBreadcrumbComponent, MaterialModule, TablerIconsModule, CommonModule, AppointmentTypeComponent,TranslateModule],
  templateUrl: './appointment-tab.component.html',
  styleUrl: './appointment-tab.component.scss'
})
export class AppointmentTabComponent {

}
